import { defineMessages } from 'react-intl';

export default defineMessages({
  error: {
    id: 'CustomerOrder.error',
    defaultMessage: 'Sorry, the order {orderId} could not be fetched.',
  },
  outboundButton: {
    id: 'JourneyItinerary.outboundButton',
    defaultMessage: 'Outbound',
  },
  inboundButton: {
    id: 'JourneyItinerary.inboundButton',
    defaultMessage: 'Inbound',
  },
});
